// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__Z8_to","footer":"ChangeClinic_footer__3QDH0"};